import MTSettings from './Settings';

export default MTSettings;